export default "__VITE_ASSET__22232065__"